import {get, post, put} from "./divertidogsApiUtils";
import {useQuery} from "@tanstack/react-query";

export interface ItemListadoServiciosEntrenamiento {
    id: string,
    nombre: string,
    descripcion?: string,
    numeroSesiones: number,
    precioTotal: number
}

export const listarServiciosEntrenamiento = async (): Promise<ItemListadoServiciosEntrenamiento[] | undefined> => {
    return get<ItemListadoServiciosEntrenamiento[]>(`servicios/entrenamiento`);
}

export interface NuevoServicioEntrenamiento {
    nombre: string,
    descripcion?: string,
    numeroSesiones: number,
    precioTotal: number
}

export const crearServicioEntrenamiento = async (nuevoServicioHotel: NuevoServicioEntrenamiento): Promise<undefined> => {
    return post<NuevoServicioEntrenamiento, any | undefined>('servicios/entrenamiento', nuevoServicioHotel);
}

export interface ServicioEntrenamiento {
    id: string,
    nombre: string,
    descripcion?: string,
    numeroSesiones: number,
    precioTotal: number
}

export const buscarServicioEntrenamiento = async (id: string): Promise<ServicioEntrenamiento| undefined> => {
    return get<ServicioEntrenamiento>(`servicios/entrenamiento/${id}`);
}

export const QUERY_KEY_BUSCAR_SERVICIO_ENTRENAMIENTO = "buscar_servicio_entrenamiento";

export const useBuscarServicioEntrenamiento = (id?: string) => {
    if(!id){
        throw Error('Id de servicio no definido');
    }
    return useQuery([QUERY_KEY_BUSCAR_SERVICIO_ENTRENAMIENTO],
        async () => await buscarServicioEntrenamiento(id)
    );
}

export const reemplazarServicioEntrenamiento = async (servicioEntrenamiento: ServicioEntrenamiento) => {
    return put<ServicioEntrenamiento, undefined>(`servicios/entrenamiento`, servicioEntrenamiento);
}